import { Component, OnInit } from "@angular/core";

@Component({
  selector: "home-index",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.css"],
})
export class IndexComponent implements OnInit {
  constructor() {}

  async ngOnInit() {}
}
